import { ReactComponent as EditIcon } from '@/assets/icons/ri-edit-line.svg';
import { ReactComponent as InvoiceIcon } from '@/assets/icons/ri-bill-line.svg';
import Button from '@/components/common/Button';
import { BOOKING_STATUS } from '@/pages/Bookings/constant';
import { ReactComponent as IcShop } from "@/assets/icons/ic_shop.svg";
import { ReactComponent as IcRescheduled } from "@/assets/icons/ri-reschedule.svg";


const getBookingMethod = (id) => {
	const bookingMethods = ['Walk In', 'Cust. App', 'Call / Chat']
	return bookingMethods[id-1]
}
export const renderTableBookingId = ({ customId, id, bookingMethodId, rescheduleToId}: {customId: string, id: string, bookingMethodId: string, rescheduleToId: string}, navigate) => (
	<div className="flex flex-col pr-7 gap-2">
		<div className="flex p-0"
				 onClick={() => navigate(`/dashboard/booking/${id}/edit`)}
				 role="button"
				 tabIndex={0}
				 onKeyDown={(e) => {e.preventDefault()}}>
			<p className="text-sm font-bold text-black-primary">{customId}</p>
		</div>
		{rescheduleToId && 
			<div className='flex flex-row gap-2'>
				<p className="group text-red-primary"  data-tooltip-target="tooltip-default">
					<IcRescheduled/>
					<div className="absolute text-xs hidden group-hover:block rounded text-white bg-red-primary px-2 py-1">
					Rescheduled
					</div>
				</p>
				<p className="text-xs text-black-primary">{rescheduleToId}</p>
			</div>
		}
		<div className='flex flex-row gap-2'>
			<IcShop/>
			<p className="text-sm text-grey-dark">{getBookingMethod(bookingMethodId)}</p>
		</div>
		
	</div>
);

export const renderTableCustomer = (customer) => (
	<div className="flex flex-col gap-2 p-0">
		<p className="font-bold text-sm">{customer.name}</p>
	</div>
);
export const renderTableBookingType = (bookingType: string) => {
	const textColor =
		bookingType === 'REGULAR' ? 'text-green-success' : 'text-purple-secondary';

	return (
		<div className="justify-start p-0">
			<div className="flex items-center pr-4 py-3 gap-3 rounded-sm">
				<p className={`font-bold text-sm ${textColor}`}>{bookingType}</p>
			</div>
		</div>
	);
};
export const renderTableCreatedDate = (createdDate) => {
	const date = new Date(createdDate)
	return (
		<div className="flex flex-col p-0 gap-3">
			<div className="flex flex-col items-start p-0 gap-1">
				<p>
					{date.toLocaleDateString('id-ID', { year: 'numeric', month: 'short', day: '2-digit' })}, {new Date(createdDate).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}
				</p>
			</div>
		</div>
	);
};
export const renderTableStatus = (status: string) => {
	const { bgColor, textColor } = BOOKING_STATUS[status];

	return (
		<div className="flex p-0">
			<div
				className={`flex items-center px-4 py-3 gap-3 rounded-sm ${bgColor}`}
			>
				<p className={`font-medium text-sm ${textColor}`}>{status}</p>
			</div>
		</div>
	);
};
export const renderTableEditButton = (v: { id: string, invoiceId: string }, navigate) => (
	<div className="flex gap-2">
		<Button
			className="border border-grey-line-subtle gap-1"
			type="button"
			variant="basic"
			onClick={() => {
				navigate(`/dashboard/invoices/${v.invoiceId}`)
			}}
		>
			<InvoiceIcon />
			Invoice
		</Button>
		<Button
			className="border border-grey-line-subtle gap-1"
			type="button"
			variant="basic"
			onClick={() => {
				navigate(`/dashboard/booking/${v.id}/edit`);
			}}
		>
			<EditIcon />
			Edit
		</Button>
	</div>
);
